import crypto from 'crypto-js';
import { v1 as uuidv1 } from 'uuid';

export default {

    isEmpty: (str) => {
        return (str === null || str === "" || str.trim().length === 0);
    },
    isEmail: (str) => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (str.trim().length > 0 && re.test(str));
    },
    isDate: (text) => {
        let comp = text.split('/');
        let d = parseInt(comp[0], 10);
        let m = parseInt(comp[1], 10);
        let y = parseInt(comp[2], 10);
        let date = new Date(y, m - 1, d);
        return (date.getFullYear() === y && date.getMonth() + 1 === m && date.getDate() === d);
    },
    toDate: (text) => {
        let comp = text.split('/');
        let d = parseInt(comp[0], 10);
        let m = parseInt(comp[1], 10);
        let y = parseInt(comp[2], 10);
        let date = new Date(y, m - 1, d);
        return date;
    },
    toDateYMD: (text) => {
        let comp = text.split('-');
        let d = parseInt(comp[2], 10);
        let m = parseInt(comp[1], 10);
        let y = parseInt(comp[0], 10);
        let date = new Date(y, m - 1, d);
        return date;
    },
    isTime: (text) => {
        let comp = text.split(':');
        let h = parseInt(comp[0], 10);
        let m = parseInt(comp[1], 10);
        return (h >= 0 && h < 24 && m >= 0 && m < 60);
    },
    isCPF: (e) => {
        e = e.replace(".", "");
        e = e.replace(".", "");
        let cpf = e.replace("-", "");
        while (cpf.length < 11) cpf = "0" + cpf;
        let t = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
        let n = [];
        let r = 0;
        let s = 11;
        let x = 0;
        for (let i = 0; i < 11; i++) {
            n[i] = cpf.charAt(i);
            if (i < 9) r += n[i] * --s;
        }
        if ((x = r % 11) < 2) {
            n[9] = 0;
        } else {
            n[9] = 11 - x;
        }
        r = 0;
        s = 11;
        for (let y = 0; y < 10; y++) r += n[y] * s--;
        if ((x = r % 11) < 2) {
            n[10] = 0;
        } else {
            n[10] = 11 - x;
        }
        let o = true;
        if (cpf.charAt(9) !== n[9] || cpf.charAt(10) !== n[10] || cpf.match(t)) o = false;
        return o;
    },
    isCNPJ: (e) => {
        e = e.trim();
        e = e.replace("/", "");
        e = e.replace(".", "");
        e = e.replace(".", "");
        e = e.replace("-", "");
        let t, n, r, i, s, o, u, a;
        a = 1;
        if (e.length < 14 && e.length < 15) {
            return false;
        }
        for (i = 0; i < e.length - 1; i++) {
            if (e.charAt(i) !== e.charAt(i + 1)) {
                a = 0;
                break;
            }
        }
        if (!a) {
            u = e.length - 2;
            t = e.substring(0, u);
            n = e.substring(u);
            r = 0;
            o = u - 7;
            for (i = u; i >= 1; i--) {
                r += t.charAt(u - i) * o--;
                if (o < 2) {
                    o = 9;
                }
            }
            s = r % 11 < 2 ? 0 : 11 - r % 11;
            if (s !== n.charAt(0)) {
                return false;
            }
            u = u + 1;
            t = e.substring(0, u);
            r = 0;
            o = u - 7;
            for (i = u; i >= 1; i--) {
                r += t.charAt(u - i) * o--;
                if (o < 2) {
                    o = 9;
                }
            }
            s = r % 11 < 2 ? 0 : 11 - r % 11;
            if (s !== n.charAt(1)) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    },
    formatDateDB: (data) => {
        return data.substr(6, 4) + "-" + data.substr(3, 2) + "-" + data.substr(0, 2);
    },    
    formatDateBR: (data) => {
        return data.substr(8, 2) + "/" + data.substr(5, 2) + "/" + data.substr(0, 4);
    },
    formatNumber: (number, decimalsLength, decimalSeparator, thousandSeparator) => {
        let n = number;
        decimalsLength = isNaN(decimalsLength = Math.abs(decimalsLength)) ? 2 : decimalsLength;
        decimalSeparator = decimalSeparator === undefined ? "," : decimalSeparator;
        thousandSeparator = thousandSeparator === undefined ? "." : thousandSeparator;
        let sign = n < 0 ? "-" : "";
        let i = parseInt(n = Math.abs(+n || 0).toFixed(decimalsLength)) + "";
        let j;
        j = (j = i.length) > 3 ? j % 3 : 0;
    
        return sign +
            (j ? i.substr(0, j) + thousandSeparator : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSeparator) +
            (decimalsLength ? decimalSeparator + Math.abs(n - i).toFixed(decimalsLength).slice(2) : "");
    },
    sha1: (str) => {
        return crypto.SHA1(str);
    },
    uuid: () => {
        return uuidv1().replace(/-/g, '');
    },
    externalLink(url){
        try{
            window.ReactNativeWebView.postMessage(url);
        }
        catch{
            window.open(url);
        }
    }
}